// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"329":"0a552494","491":"efc39742"}[chunkId] + ".css";
};